import { cn } from '@/lib/shadcn/utils';
import type { LegalDocumentApi } from '@/modules/legal/types';

interface TermsNoticeProps {
  /** How the sentence opens, e.g. "By signing up". */
  lead: string;
  terms?: LegalDocumentApi;
  className?: string;
}

/**
 * The Terms Notice under the sign-in buttons. Signing up or claiming an
 * account under it accepts the Terms, but only once the link has loaded, so
 * callers send `acceptTerms` only when `terms.url` is set.
 */
export function TermsNotice({ lead, terms, className }: TermsNoticeProps) {
  return (
    <p
      className={cn(
        'text-muted-foreground text-[13px] leading-[19px]',
        className,
      )}
    >
      {lead}, you agree to Finlay&apos;s{' '}
      {terms?.url ? (
        <a
          className="text-foreground underline underline-offset-2"
          href={terms.url}
          rel="noopener noreferrer"
          target="_blank"
        >
          Terms &amp; Conditions
        </a>
      ) : (
        'Terms & Conditions'
      )}
      , including the DPA, on behalf of your organisation.
    </p>
  );
}
